//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated by the Rock.CodeGeneration project
//     Changes to this file will be lost when the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------
// <copyright>
// Copyright by the Spark Development Network
//
// Licensed under the Rock Community License (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.rockrms.com/license
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
// </copyright>
//

/** How signature document should be presented to registrant */
export const SignatureDocumentAction = {
    /** Email document */
    Email: 0,

    /** Embed document in registration */
    Embed: 1
} as const;

/** How signature document should be presented to registrant */
export const SignatureDocumentActionDescription: Record<number, string> = {
    0: "Email",

    1: "Embed"
};

/** How signature document should be presented to registrant */
export type SignatureDocumentAction = typeof SignatureDocumentAction[keyof typeof SignatureDocumentAction];
